import React from 'react';
import { Create } from 'react-admin';
import LayerForm from '../LayerForm';

function LayerCreate(props) {
  return (
    <Create {...props}>
      <LayerForm redirect="list" />
    </Create>
  );
}

export default LayerCreate;
